import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pd-toc"
}
const _hoisted_2 = { class: "pd-toc__head" }
const _hoisted_3 = {
  viewBox: "0 0 36 36",
  width: "22",
  height: "22",
  "aria-hidden": "true",
  class: "pd-toc__ring"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "18",
  cy: "18",
  r: "15.9",
  pathLength: "100"
}, null, -1 /* HOISTED */)
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.items.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("circle", {
              cx: "18",
              cy: "18",
              r: "15.9",
              pathLength: "100",
              class: "pd-toc__ring-value",
              style: _normalizeStyle({ strokeDasharray: `${Math.round($props.progress * 100)} 100` })
            }, null, 4 /* STYLE */)
          ])),
          _createElementVNode("p", null, _toDisplayString($props.label), 1 /* TEXT */)
        ]),
        _createElementVNode("nav", { "aria-label": $props.label }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, (item) => {
            return (_openBlock(), _createElementBlock("a", {
              key: item.id,
              href: `#${item.id}`,
              class: _normalizeClass(['pd-toc__item', `is-level-${item.level}`, { 'is-active': item.id === $props.active }])
            }, _toDisplayString(item.text), 11 /* TEXT, CLASS, PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ], 8 /* PROPS */, _hoisted_5),
        _createElementVNode("a", {
          class: "pd-toc__top",
          href: "#ps-main",
          onClick: _withModifiers($setup.toTop, ["prevent"])
        }, _toDisplayString($props.topLabel) + " ↑", 9 /* TEXT, PROPS */, _hoisted_7)
      ]))
    : _createCommentVNode("v-if", true)
}